import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
// @ts-expect-error untyped module
import isMobile from 'isMobile';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
const OrderDescription = ({
  checkoutSession
}) => {
  if (!checkoutSession.descriptionHtml) {
    return null;
  }
  const descriptionHtml = () => {
    return /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: checkoutSession.descriptionHtml
      }
    });
  };
  return /*#__PURE__*/_jsx(CardWrapper, {
    marginBlockEnd: "400",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "600",
      children: isMobile.any ? /*#__PURE__*/_jsx(ExpandableText, {
        children: descriptionHtml()
      }) : descriptionHtml()
    })
  });
};
export default OrderDescription;